import { render, staticRenderFns } from "./mainContent.vue?vue&type=template&id=656bd884&"
import script from "./mainContent.vue?vue&type=script&lang=js&"
export * from "./mainContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VContainer,VFlex,VLayout,VMain,VToolbar})
